/*=========================================================================================
  File Name: modulePurchaseOrderState.js
  Description: Purchase Order Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
